import _regeneratorRuntime from "babel-runtime/regenerator";

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";
import { RoundCheck, Processing } from "../../Misc/Icons";
import { grabVideoFrame } from "../Utils";

var ThumbnailOption = function (_React$Component) {
  _inherits(ThumbnailOption, _React$Component);

  function ThumbnailOption() {
    var _this2 = this;

    var _temp, _this, _ret;

    _classCallCheck(this, ThumbnailOption);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      thumbnail: null,
      thumbnailLoaded: false
    }, _this.componentDidMount = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var _this$props, videoSrc, time, thumbnailMaxSize, thumbnailQuality, thumbnail;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props = _this.props, videoSrc = _this$props.videoSrc, time = _this$props.time, thumbnailMaxSize = _this$props.thumbnailMaxSize, thumbnailQuality = _this$props.thumbnailQuality;
              _context.next = 3;
              return grabVideoFrame(videoSrc, time, thumbnailQuality, thumbnailMaxSize);

            case 3:
              thumbnail = _context.sent;

              _this.setState({
                thumbnailLoaded: true,
                thumbnail: thumbnail
              });

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    })), _temp), _possibleConstructorReturn(_this, _ret);
  }

  ThumbnailOption.prototype.render = function render() {
    var _props = this.props,
        isSelected = _props.isSelected,
        time = _props.time,
        _onClick = _props.onClick;
    var _state = this.state,
        thumbnail = _state.thumbnail,
        thumbnailLoaded = _state.thumbnailLoaded;

    if (thumbnailLoaded && !thumbnail) {
      return null;
    }

    return React.createElement("div", {
      className: "recorder__thumbs-item " + (isSelected ? "is-active" : ""),
      style: {
        textAlign: "center"
      },
      onClick: function onClick() {
        return _onClick(time);
      }
    }, thumbnail ? React.createElement(React.Fragment, null, React.createElement(RoundCheck, null), React.createElement("div", {
      style: {
        backgroundImage: "url(" + thumbnail + ")"
      }
    })) : React.createElement(Processing, null));
  };

  return ThumbnailOption;
}(React.Component);

ThumbnailOption.propTypes = process.env.NODE_ENV !== "production" ? {
  videoSrc: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  isSelected: PropTypes.bool,
  time: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  thumbnailQuality: PropTypes.number,
  thumbnailMaxSize: PropTypes.number
} : {};
export default ThumbnailOption;